import ctl from '@netlify/classnames-template-literals'
import { motion } from 'motion/react'
import { useEffect, useRef, useState } from 'react'

export type AnimateChangeInSizeProps = {
	children: React.ReactNode
	className?: string
	duration?: number
	hideOverflow?: boolean
}

export function AnimateChangeInSize(
	{ children, className, duration = 0.3, hideOverflow = false }: AnimateChangeInSizeProps,
) {
	const containerRef = useRef<HTMLDivElement>(null)
	const [size, setSize] = useState<{ width: number | 'auto'; height: number | 'auto' }>({
		width: 'auto',
		height: 'auto',
	})

	useEffect(() => {
		const container = containerRef.current
		if (!container) { return }

		const resizeObserver = new ResizeObserver((entries) => {
			const observedWidth = entries[0].contentRect.width
			const observedHeight = entries[0].contentRect.height
			setSize({ width: observedWidth, height: observedHeight })
		})

		resizeObserver.observe(container)
		return () => resizeObserver.disconnect()
	}, [])

	return (
		<motion.div
			className={ctl(`${hideOverflow && 'overflow-hidden'} relative ${className}`)}
			animate={{ width: size.width, height: size.height }}
			transition={{ duration, type: 'spring' }}
		>
			<div
				ref={containerRef}
				className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
				style={{ width: 'max-content' }}
			>
				{children}
			</div>
		</motion.div>
	)
}
